<template>
    <div class="planos">
        <Header></Header>
        <div class="container">
            <div class="row my-5">
                <div class="col-12 col-md-6">
                    <span class="txt-p txt-size-20 txt-w-bold txt-roxo-1">Escolha quantas orientações você precisar.</span>
                    
                    <p class="txt-p txt-cores-1 ">
                        Preencha o formulário ao lado e converse com um profissional que irá identificar qual o melhor plano para você e sua instituição!
                    </p>
                </div>
                <div class="col-12 col-md-6">
                    <div class="a-partir d-flex justify-content-center">
                        <span class="txt-p txt-roxo-1 txt-size-20">Planos a partir de <span class="txt-w-bold txt-size-25">R$ 4.800</span>,00</span>
                    </div>

                    <FormContato class="mt-3" :txtBotao="'FAZER CONSULTA'"></FormContato>
                </div>
            </div>

        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import FormContato from '@/components/FormContato'

    export default {
        name: 'Planos',
        components: { Header, FormContato, Footer },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .planos{

    }

    .a-partir {
        padding: 20px 0;
        border: 3px solid #732A90;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
    }

</style>

